module.exports = __webpack_public_path__ + "img/logo_portrait_light.10dbbf75.svg";